import CitySEOHead from "@/components/feature/CitySEOHead";
import KennerHeroSection from "./components/HeroSection";
import KennerStickyNav from "./components/StickyNav";
import KennerProcessingTimeSection from "./components/ProcessingTimeSection";
import KennerServicesSection from "./components/ServicesSection";
import KennerLocalAreaSection from "./components/LocalAreaSection";
import KennerTestimonialsSection from "./components/TestimonialsSection";
import KennerAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import KennerComparisonSection from "./components/ComparisonSection";
import KennerMistakesSection from "./components/MistakesSection";
import KennerHowItWorksSection from "./components/HowItWorksSection";
import KennerFAQSection, { faqs } from "./components/FAQSection";
import KennerHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import KennerFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import KennerTravelTimingSection from "./components/TravelTimingSection";
import KennerDestinationsSection from "./components/DestinationsSection";

export default function KennerPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Kenner"
        state="Louisiana"
        stateAbbr="LA"
        route="/kenner"
        title="Emergency Passport Kenner, LA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Kenner, LA — as fast as 24 hours. Serving MSY airport workers, Jefferson Parish families, and New Orleans cruise passengers. A+ BBB rated, registered State Dept. courier."
        geoPlacename="Kenner, Louisiana"
        geoPosition="29.9941;-90.2417"
        faqs={faqs}
        servicesSchema={[
          { name: "Emergency Passport", description: "Urgent passport processing for Kenner travelers with immediate departure needs — as fast as 24 hours for MSY airport workers and Jefferson Parish residents." },
          { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens in Kenner with an expired or expiring passport." },
          { name: "New Passport", description: "First-time passport application assistance for Kenner families and New Orleans cruise passengers." },
          { name: "Lost or Stolen Passport", description: "Passport replacement for lost or stolen passports with DS-64 form guidance in Kenner, LA." },
          { name: "Child Passport", description: "Passport services for minors under 16 with parental consent guidance for Jefferson Parish families." },
          { name: "Name Change", description: "Passport correction and name change service for Kenner residents after marriage or legal changes." },
          { name: "Second Passport", description: "Second passport service for MSY airport professionals and frequent international travelers from Kenner." },
        ]}
        statePageName="Louisiana"
        statePageRoute="/states/louisiana"
      />
      <KennerHeroSection />
      <KennerStickyNav />
      <KennerProcessingTimeSection />
      <KennerLocalAreaSection />
      <KennerServicesSection />
      <KennerTravelTimingSection />
      <KennerDestinationsSection />
      <KennerTestimonialsSection />
      <KennerAcceptanceFacilitiesSection />
      <KennerComparisonSection />
      <KennerMistakesSection />
      <KennerHowItWorksSection />
      <KennerFAQSection />
      <KennerHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/kenner" state="LA" />
      <KennerFinalCTA />
    </div>
  );
}